import { Link } from 'react-router';
import { cn } from '@/lib/cn';
import { LEGAL_ROUTES } from './legal.config';

const linkClass = 'underline-offset-4 hover:underline';

/** Links para a Política e os Termos. `newTab` abre em outra aba (usado ao lado de formulários, para não perder o preenchimento). */
export function LegalLinks({ className, linkClassName, newTab, onNavigate }: { className?: string; linkClassName?: string; newTab?: boolean; onNavigate?: () => void }) {
  const extra = newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {};
  return (
    <nav aria-label="Documentos legais" className={cn('flex flex-wrap items-center gap-x-4 gap-y-1 text-xs', className)}>
      <Link to={LEGAL_ROUTES.privacy} className={cn(linkClass, linkClassName)} onClick={onNavigate} {...extra}>
        Política de Privacidade
      </Link>
      <Link to={LEGAL_ROUTES.terms} className={cn(linkClass, linkClassName)} onClick={onNavigate} {...extra}>
        Termos de Uso
      </Link>
    </nav>
  );
}
